module.exports = __webpack_public_path__ + "img/introductors.fb8a24f4.png";